import { gql } from "@apollo/client";

export const previewWebLensOnDevice = gql`
    mutation previewWebLensOnDevice($input: PreviewWebLensOnDeviceRequest!) {
        previewWebLensOnDevice(input: $input) {
            previewLensId
            validation {
                name
                passed
                detail
                # Deploy after the BFF adds this field; otherwise the whole mutation fails validation.
                rejection {
                    reason
                    key
                    data
                    omittedCount
                    findings {
                        ruleId
                        file
                        line
                        column
                        occurrences
                    }
                }
            }
        }
    }
`;
